import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GetPartnerTagsService } from './get-partner-tags.service';

@NgModule({
  imports: [CommonModule],
  providers: [GetPartnerTagsService],
})
export class GetPartnerTagsModule {}
